<template>
    <div class="content-wrapper">
        <modals-container></modals-container>
        <div class="page-heading">
            <div class="page-content fade-in-up">
                <div class="row">
                    <div class="col-md-12">
                        <div class="ibox">
                            <div class="ibox-body">
                                <ul class="nav nav-tabs tabs-line">
                                    <li class="nav-item">
                                        <a class="nav-link active" href="#tab-1" data-toggle="tab">{{$t('message.info')}}</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" href="#tab-2" data-toggle="tab">{{$t('message.changePassword')}}</a>
                                    </li>
                                </ul>
                                <div class="tab-content">
                                    <div v-if="user" id="tab-1" class="tab-pane fade active show">
                                        <div class="row">
                                            <div class="col-md-4">
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="row">
                                                    <div class="col-md-2">
                                                        <div class="row">
                                                            <div class="gallery">
                                                                <div class="image-wrapper"
                                                                     @click="$refs.imageInput.click()">
                                                                    <a target="_blank" @mouseover="showToolTip=true"
                                                                       @mouseleave="showToolTip=false">
                                                                        <img :src="$store.getters.getProfileImage"
                                                                             width="600"
                                                                             height="400">
                                                                    </a>

                                                                    <input type="file"
                                                                           style="display:none"
                                                                           @input="addImage"
                                                                           id="imageInput"
                                                                           ref="imageInput">

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="row">
                                                            <div class="col-md-4">
                                                               <span class="tooltiptext"
                                                                     v-bind:class="{ tooltiptextvisible : showToolTip }"
                                                               > {{$t('message.addUpdateProfileImage')}} </span>
                                                                <div class="form-group">
                                                                    <label>{{$t('message.email')}}</label>
                                                                    <input v-model="user.email" type="email"
                                                                           class="form-control"
                                                                           :placeholder="$t('message.email')">
                                                                </div>
                                                            </div>
                                                            <div class="col-md-4">
                                                                <div class="form-group">
                                                                    <label>{{$t('message.companyName')}}</label>
                                                                    <input v-model="user.company_name" type="text"
                                                                           class="form-control"
                                                                           :placeholder="$t('message.companyName')">
                                                                </div>
                                                            </div>
                                                            <div class="col-md-4">
                                                                <div class="form-group">
                                                                    <label>{{$t('message.companyAbbreviation')}}</label>
                                                                    <input v-model="user.company_abbreviation"
                                                                           type="text"
                                                                           class="form-control"
                                                                           :placeholder="$t('message.companyAbbreviation')">
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!-- Company name and website -->
                                                        <div class="row">
                                                            <div class="col-md-3">
                                                                <div class="form-group">
                                                                    <label>{{$t('message.firstName')}}</label>
                                                                    <input v-model="user.first_name" type="text"
                                                                           class="form-control"
                                                                           :placeholder="$t('message.firstName')">
                                                                </div>
                                                            </div>
                                                            <div class="col-md-3">
                                                                <div class="form-group">
                                                                    <label>{{$t('message.lastName')}}</label>
                                                                    <input v-model="user.last_name" type="text"
                                                                           class="form-control"
                                                                           :placeholder="$t('message.lastName')">
                                                                </div>
                                                            </div>
                                                            <div class="col-md-3">
                                                                <div class="form-group">
                                                                    <label>{{$t('message.companyWebsite')}}</label>
                                                                    <input v-model="user.company_website" type="text"
                                                                           class="form-control"
                                                                           :placeholder="$t('message.companyWebsite')">
                                                                </div>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <div class="form-group">
                                                                    <label>{{$t('message.preferredLanguage')}}</label>
                                                                    <select @change="setLang" style="min-width: 135px"
                                                                            class="form-control"
                                                                            v-model="user.preferred_language">
                                                                        <option value="en">EN</option>
                                                                        <option value="de">DE</option>
                                                                        <option value="fr">FR</option>
                                                                        <option value="it">IT</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!--Address data-->
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <div class="form-group">
                                                            <label>{{$t('message.city')}}</label>
                                                            <input v-model="user.city" type="text"
                                                                   class="form-control"
                                                                   :placeholder="$t('message.city')">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                       <div class="form-group">
                                                            <!-- <label>{{$t('message.state')}}</label>
                                                            <input v-model="user.state" type="text"
                                                                   class="form-control"
                                                                   :placeholder="$t('message.state')"> -->
                                                              <label>{{$t('message.zipCode')}}</label>
                                                                <input v-model="user.zip_code" type="text"
                                                                   class="form-control"
                                                                   :placeholder="$t('message.zipCode')">   
                                                          </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="form-group">
                                                            <!-- <label>{{$t('message.country')}}</label>
                                                            <input v-model="user.country" type="text"
                                                                   class="form-control"
                                                                   :placeholder="$t('message.country')"> -->
                                                             
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label>{{$t('message.street')}}</label>
                                                                <input v-model="user.street" type="text"
                                                                   class="form-control"
                                                                   :placeholder="$t('message.street')">
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="form-group">
                                                             <label>{{$t('message.streetNr')}}</label>
                                                            <input v-model="user.street_number" type="text"
                                                                   class="form-control"
                                                                   :placeholder="$t('message.streetNr')">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="form-group">
                                                           
                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <add-edit-phones :user="user"></add-edit-phones>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <contact-multi-select
                                                        v-if="showMultiSelect"
                                                        @removedJob="jobRemoved($event)"
                                                        @selectedJob="chosenJob($event)"
                                                        :contactsSelected="computedUserJobs"
                                                        :contacts="jobs"></contact-multi-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12 text-center">
                                                <button @click="updateProfile" style="margin: 1%;"
                                                        class="btn btn-primary">
                                                    {{$t('message.update')}}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="tab-2" class="tab-pane fade active-show">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <div class="form-group">
                                                            <label>{{$t('message.currentPassword')}}</label>
                                                            <input v-model="old_password" class="form-control"
                                                                   type="password"
                                                                   :placeholder="$t('message.currentPassword')">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="form-group">
                                                            <label>{{$t('message.newPassword')}}</label>
                                                            <input v-model="new_password" class="form-control"
                                                                   type="password"
                                                                   :placeholder="$t('message.newPassword')">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="form-group">
                                                            <label>{{$t('message.repeatNewPassword')}}</label>
                                                            <input v-model="new_password_confirm" class="form-control"
                                                                   type="password"
                                                                   :placeholder="$t('message.repeatNewPassword')">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-12 text-center pt-2">
                                                        <button @click="changePassword" class="btn btn-primary">
                                                            {{$t('message.changePassword')}}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import OkModal            from '../modals/OkModal'
  import AddEditPhones      from './misc/AddEditPhones'
  import ContactMultiSelect from './misc/ContactMultiSelect'

  export default {
    name: 'Profile',
    data () {
      return {
        showToolTip: false,
        showMultiSelect: false,
        new_password_confirm: '',
        new_password: '',
        old_password: '',
        user: null,
        phoneType: '',
        phoneNumber: '',
        oldNumber: null,
        jobs: []
      }
    },
    components: {
      AddEditPhones,
      ContactMultiSelect
    },
    mounted () {
      this.get(this.apiPrefix, this.userApiUrl, '/' + this.$store.getters.getAuth['userId'])
        .then(resp => {
          this.user = resp.data
          if (resp.data.profile_image)
            this.user.profile_image = resp.data.profile_image.image
        })
        .catch(err => {
          console.log(err)
        })

      // get jobs
      this.getList(this.apiPrefix, this.jobApiUrl).then(resp => {
        this.jobs = resp.data
        this.showMultiSelect = true
      }).catch(err => {
        console.log(err.response)
      })
    },
    methods: {
      addImage (event) {

        // in case uploaded file is jpg or png else alert error
        if (this.isFileImage(event.target.files[0])) {

          const fd = new FormData()
          // add image selected in the event and his name to the FormData object
          fd.append('image', event.target.files[0], event.target.files[0].name)
          this.update(this.apiPrefix, this.userApiUrl + '/profile-image/', '', fd)
            .then(res => {
              this.user.profile_image = res.data.image
              this.$store.commit('setProfileImage', this.user.profile_image);
              document.getElementById('imageInput').value = ''
            }).catch(err => {
            console.log(err.response)
          })
        }
        else {
          this.$modal.show(OkModal, {
              text: this.$t('message.provideCorrectFormat'),
              modalClass: this.modalClasses.okErrorClass
            },
            {
              width: this.modalWidth(),
              height: 'auto'
            })
        }

      },
      editPhoneSet (phone) {
        this.phoneNumber = phone.number
        this.phoneType = phone.type
        this.oldNumber = phone.number
      },
      editPhone () {
        this.user.phones = this.user.phones.map(obj => {
          if (obj.number === this.oldNumber) {
            obj.number = this.phoneNumber
            obj.type = this.phoneType
          }
          return obj
        })

        this.oldNumber = null
        this.phoneNumber = ''
        this.phoneType = ''
      },
      removePhone (number) {
        this.user.phones = this.user.phones.filter(obj => {
          return obj.number !== number
        })
      },
      addPhone () {
        let msg = ''

        if (this.phoneType === '') {
          msg = this.$t('message.providePhoneType')
        }

        if (this.phoneNumber === '') {
          msg = this.$t('message.providePhoneNumber')
        }

        if (this.user && this.phoneNumber && this.phoneType) {
          this.user.phones.push({type: this.phoneType, number: this.phoneNumber})
          this.phoneType = ''
          this.phoneNumber = ''
        } else {
          this.$modal.show(OkModal, {
              text: msg,
              modalClass: this.modalClasses.okErrorClass
            },
            {
              width: this.modalWidth(),
              height: 'auto'
            })
        }
      },
      updateProfile () {
        let self = this

        this.update(this.apiPrefix, this.userApiUrl + '/', this.user.id, this.user)
          .then(() => {
            self.$modal.show(OkModal, {
                text: self.$t('message.profileUpdated'),
                modalClass: self.modalClasses.okSuccessClass
              },
              {
                width: self.modalWidth(),
                height: 'auto'
              })

            self.$store.commit('setFullName', `${this.user.first_name} ${this.user.last_name}`)
          })
          .catch(err => {
            let msg = self.createErrorMessage(self.parseErrors(err.response.data.errors))

            self.$modal.show(OkModal, {
                text: msg,
                modalClass: self.modalClasses.okErrorClass
              },
              {
                width: self.modalWidth(),
                height: 'auto'
              })
          })
      },
      jobRemoved (obj) {
        let index = this.user.jobs.indexOf(obj)
        this.user.jobs.splice(index, 1)
      },
      chosenJob (obj) {
        this.user.jobs.push(obj)
      },
      changePassword () {
        let self = this

        this.update(this.apiPrefix, this.authApiUrl + '/change-password/', '',
          {
            new_password: this.new_password,
            old_password: this.old_password,
            new_password_confirm: this.new_password_confirm
          }).then(() => {
          // update auth values (new csrf token) especially
          let authValues = this.setAuthValues(...self.authRegex)

          self.$store.commit('setAuth', authValues)

          self.$modal.show(OkModal, {
              text: self.$t('message.changedPassword'),
              modalClass: self.modalClasses.okSuccessClass
            },
            {
              width: self.modalWidth(),
              height: 'auto'
            })
        }).catch(err => {
          let errMsg = self.firstLetterLowerCase(self.toTitleCase(err.response.data.data[0], ' '))
          errMsg = errMsg.substring(0, errMsg.length - 1)

          self.$modal.show(OkModal, {
              text: self.$t(`message.${errMsg}`),
              modalClass: self.modalClasses.okErrorClass
            },
            {
              width: self.modalWidth(),
              height: 'auto'
            })
        })
      },
      setLang () {
        this.changeLocale(this.user.preferred_language)
      }
    },
    computed: {
      computedUserJobs () {
        return this.user.jobs
      }
    }
  }
</script>

<style scoped>
    label {
        font-weight: bold;
    }

    select {
        width: 50px;
    }

    div.gallery {
        margin: 0 auto;
        border: 1px solid rgb(214, 214, 214);
        padding: 5px;
        border-radius: 4px;
        float: left;
        width: 180px;
        height: 140px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }

    div.gallery:hover {
        box-shadow: 0 0 2px 1px rgba(0, 140, 186, 0.5);
    }

    div.gallery img {
        margin: 4%;
        width: 92%;
        height: auto;
    }

    .tooltiptext {
        visibility: hidden;
        width: 120px;
        background-color: #000;
        color: #fff;
        text-align: center;
        border-radius: 6px;
        padding: 5px 0;
        position: absolute;
        left: -10px;

    }

    .image-wrapper {
        height: 100%;
        width: 100%;
    }

    .tooltiptextvisible {
        visibility: visible;
        z-index: 1;
    }

</style>